export function extractCountryCodeAndMobile(mobile: string | undefined) {
    if (!mobile) return { countryCode: '+61', mobile: '' }
    const trimmed = mobile.replace(/\s+/g, '').trim()
    if (trimmed.startsWith('+64')) {
        return { countryCode: '+64', mobile: trimmed.replace(/^\+64\s?/, '') }
    }
    if (trimmed.startsWith('+61')) {
        return { countryCode: '+61', mobile: trimmed.replace(/^\+61\s?/, '') }
    }
    // fallback: default to +61, use as-is
    return { countryCode: '+61', mobile: trimmed }
}

export function formatMobileForDisplay(mobile: string | undefined) {
    if (!mobile) return ''
    const { countryCode, mobile: localMobile } = extractCountryCodeAndMobile(mobile)
    if (!localMobile) return `(${countryCode})`
    // For AU/NZ, format as (+614) 1234 5678 or (+642) 112 3456
    if ((countryCode === '+61' || countryCode === '+64') && localMobile.length >= 6) {
        const prefix = localMobile.slice(0, 1)
        let part1, part2
        if (countryCode === '+61') {
            part1 = localMobile.slice(1, 5)
            part2 = localMobile.slice(5)
        } else {
            part1 = localMobile.slice(1, 4)
            part2 = localMobile.slice(4)
        }
        return `(${countryCode}${prefix}) ${part1} ${part2}`.trim()
    }
    // fallback: just show country code and number
    return `(${countryCode}) ${localMobile}`
}
